export default __webpack_public_path__ + "9b0cc84f45871738db358e497c4e7ebb.png";